import React, { useState } from 'react';
import { Users, BookOpen, Bell } from 'lucide-react'; 
import DeviceGroupsTab from './DeviceGroupsTab';
import DictionariesTab from './DictionariesTab';
import NotificationsTab from './NotificationsTab';

const MainSettingsPage = () => {
    const [activeTab, setActiveTab] = useState('groups');

    const [userInfo] = useState(() => {
        const stored = localStorage.getItem('userInfo');
        return stored ? JSON.parse(stored) : null;
    });

    const tabs = [
        { id: 'groups', name: 'Группировка объектов учета', icon: Users },
        { id: 'dictionaries', name: 'Справочники', icon: BookOpen },
        { id: 'notifications', name: 'Уведомления', icon: Bell }, // ✅ новая вкладка
    ];

    return (
        <div className="space-y-4">
            <div>
                <h1 className="text-2xl font-bold text-white">Настройки</h1>
                <p className="text-slate-400 text-sm mt-1">
                    Параметры системы и управление объектами учета
                </p>
            </div>

            {/* Панель вкладок */}
            <div className="flex gap-1 border-b border-slate-700 overflow-x-auto">
                {tabs.map(tab => {
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition whitespace-nowrap ${activeTab === tab.id
                                    ? 'border-blue-500 text-blue-400'
                                    : 'border-transparent text-slate-400 hover:text-white'
                                }`}
                        >
                            <Icon className="w-4 h-4" />
                            {tab.name}
                        </button>
                    );
                })}
            </div>

            {/* Контент вкладок */}
            <div className="min-h-[400px]">
                {activeTab === 'groups' && <DeviceGroupsTab userInfo={userInfo} />}
                {activeTab === 'dictionaries' && <DictionariesTab userInfo={userInfo} />}
                {activeTab === 'notifications' && <NotificationsTab userInfo={userInfo} />} {/* ✅ новый рендер */}
            </div>
        </div>
    );
};

export default MainSettingsPage;